import React from 'react';
import { Dashboard, PageLayout, TabPills, useDashboardFeatureFlags } from '@components';
import { Dropdown, HeadContent, ToolbarButton, useMediaQueryContext } from '@fourthwall/components';
import { DotsHorizontalIcon } from '@fourthwall/icons';
import { isWebView } from '@fourthwall/utils';
import { routing } from '@utils/routing';
import { AnalyticsLayout } from '../../analyticsModule/components/AnalyticsLayout/AnalyticsLayout';
import { AnalyticsToolbar } from '../../analyticsModule/components/AnalyticsToolbar/AnalyticsToolbar';
import { AnalyticsCompareDateRangeSelect } from '../../analyticsModule/components/tools/AnalyticsCompareDateRangeSelect/AnalyticsCompareDateRangeSelect';
import { AnalyticsDateRangeSelect } from '../../analyticsModule/components/tools/AnalyticsDateRangeSelect/AnalyticsDateRangeSelect';
import { AnalyticsGroupBySelect } from '../../analyticsModule/components/tools/AnalyticsGroupBySelect/AnalyticsGroupBySelect';
import { useAnalyticsTabs } from '../../hooks/useAnalyticsTabs';
import { useAnalyticsParams } from '../../modules/AnalyticsParams/hooks/useAnalyticsParams';
import { DefaultAnalytics } from '../../modules/DefaultAnalytics/DefaultAnalytics';
import { GoogleAnalyticsBanner } from '../../modules/GoogleAnalytics/components/GoogleAnalyticsBanner/GoogleAnalyticsBanner';
import { GoogleAnalyticsBar } from '../../modules/GoogleAnalytics/components/GoogleAnalyticsBar/GoogleAnalyticsBar';
import { MembershipsAnalytics } from '../../modules/MembershipsAnalytics/MembershipsAnalytics';
import { OverviewAnalytics } from '../../modules/OverviewAnalytics/OverviewAnalytics';
import { ShopAnalytics } from '../../modules/ShopAnalytics/ShopAnalytics';
import { BottomContent } from './components/BottomContent/BottomContent';
export const AnalyticsDashboard = () => {
    const { areTabsEnabled, tabsOptions, activeTab, onTabChange } = useAnalyticsTabs();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const media = useMediaQueryContext();
    const { dateRange, compareDateRange, groupBy } = useAnalyticsParams();
    const renderContent = () => {
        if (!areTabsEnabled) {
            return React.createElement(DefaultAnalytics, null);
        }
        switch (activeTab) {
            case 'overview':
                return React.createElement(OverviewAnalytics, null);
            case 'shop':
                return React.createElement(ShopAnalytics, null);
            case 'memberships':
                return React.createElement(MembershipsAnalytics, null);
        }
    };
    const settings = [
        {
            enabled: dashboardFeatureFlags.analyticsTrackingPixels.enabled,
            label: 'Tracking pixels',
            // TODO: change to analytics v2
            to: routing.analytics.overview.trackingPixels,
        },
    ].filter(({ enabled = true }) => enabled);
    const renderSettings = () => {
        if (isWebView() || !settings.length)
            return null;
        return (React.createElement(Dropdown, { content: settings.map((settingsItem, index) => (React.createElement(Dropdown.Item, { key: index, ...settingsItem }))), position: "bottom-end" },
            React.createElement(ToolbarButton, { placement: "top-end", label: "Settings", icon: DotsHorizontalIcon })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Analytics", titleTemplate: isWebView() ? 'Analytics' : undefined }),
        React.createElement(PageLayout, { size: "full" },
            React.createElement(Dashboard.Section, { toolbarContent: areTabsEnabled && media.tablet ? undefined : renderSettings(), name: isWebView() ? undefined : 'Analytics', bottomContent: React.createElement(BottomContent, { actions: areTabsEnabled && media.tablet ? renderSettings() : undefined }, areTabsEnabled && (React.createElement(TabPills, { options: tabsOptions, value: activeTab, size: "large", onChange: onTabChange }))) },
                React.createElement(AnalyticsLayout, { toolbar: React.createElement(AnalyticsToolbar, { bottomContent: React.createElement(GoogleAnalyticsBanner, null) },
                        React.createElement(AnalyticsDateRangeSelect, { ...dateRange }),
                        dashboardFeatureFlags.analyticsV2Compare.enabled && (React.createElement(AnalyticsCompareDateRangeSelect, { ...compareDateRange })),
                        React.createElement(AnalyticsGroupBySelect, { ...groupBy }),
                        React.createElement(GoogleAnalyticsBar, null)) }, renderContent())))));
};
